<template>
  <div>
    <p>To enable auditing in ServicePulse, you need to setup a ServiceControl Audit instance. There are multiple ways to do this:</p>
    <ul>
      <li>
        <strong><a href="https://docs.particular.net/servicecontrol/audit-instances/deployment/powershell" target="_blank">Scripted Deployment</a></strong> - Use a script to automate the installation and configuration of the audit instance
      </li>
      <li>
        <strong><a href="https://docs.particular.net/servicecontrol/audit-instances/deployment/containers" target="_blank">Containers</a></strong> - Run the audit instance inside a container
      </li>
      <li>
        <strong><a href="https://docs.particular.net/servicecontrol/audit-instances/deployment/scmu" target="_blank">ServiceControl Management Utility</a></strong> - Use the management utility to create and configure the audit instance
      </li>
    </ul>
    <p>The audit instance stores processed messages and makes them available for viewing in ServicePulse.</p>
  </div>
</template>
